'use client';

import { __makeTemplateObject } from '../_virtual/_tslib.js';
import styled from 'styled-components';
import themes, { sizes } from './themes.js';

var tagVars = ['--vnw-tag-gap-top', '--vnw-tag-gap-right', '--vnw-tag-gap-bottom', '--vnw-tag-gap-left'];
var TagContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n"], ["\n    ", "\n"])), function (_a) {
    var variant = _a.variant, color = _a.color, size = _a.size;
    /**
     * Theme color
     * */
    var theme = themes[color][variant];
    var backgroundColor = theme.background;
    var borderColor = theme.border;
    /**
     * Size
     * */
    var tagSize = sizes[size];
    var height = tagSize.height;
    var paddingLeft = tagSize.paddingLeft;
    var paddingRight = tagSize.paddingRight;
    return "\n            display: flex;\n            align-items: center;\n            background-color: ".concat(backgroundColor, ";\n            border: 1px solid ").concat(borderColor, ";\n            height: calc(").concat(height, " - var(").concat(tagVars[0], ", 0px) - var(").concat(tagVars[2], ", 0px));\n            padding-left: calc(").concat(paddingLeft, ");\n            padding-right: ").concat(paddingRight, ";\n            border-radius: 6px;\n            cursor: pointer;\n            margin: var(").concat(tagVars[0], ", 0px) var(").concat(tagVars[1], ", 0px) var(").concat(tagVars[2], ", 0px) var(").concat(tagVars[3], ", 0px);\n            & > .tag-typo {\n                display: -webkit-box;\n                -webkit-line-clamp: 1;\n                -webkit-box-orient: vertical;\n                overflow: hidden;\n                word-break: break-all;\n            }\n        ");
});
var CloseButton = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    margin-left: 4px;\n    cursor: pointer;\n"], ["\n    display: flex;\n    margin-left: 4px;\n    cursor: pointer;\n"])));
var templateObject_1, templateObject_2;

export { CloseButton, TagContainer };
//# sourceMappingURL=styles.js.map
